<template>
  <DsShowcase title="FieldPlay" description="Wrapper de campo com label, description e slot para conteúdo. Componente de layout, não de input.">
    <!-- PROP: label -->
    <section>
      <h2 class="tw:text-base tw:font-semibold tw:mb-1">label</h2>
      <p class="tw:text-xs tw:opacity-50 tw:mb-4"><code>string</code> — label acima do slot</p>
      <div class="tw:max-w-lg tw:space-y-4">
        <FieldPlay label="Nome completo">
          <InputPlayV3 v-model="v1" placeholder="João Silva" />
        </FieldPlay>
      </div>
    </section>

    <!-- PROP: description -->
    <section>
      <h2 class="tw:text-base tw:font-semibold tw:mb-1">description</h2>
      <p class="tw:text-xs tw:opacity-50 tw:mb-4"><code>string</code> — texto auxiliar abaixo do campo</p>
      <div class="tw:max-w-lg tw:space-y-4">
        <FieldPlay label="E-mail" description="Será usado para login e recuperação de senha.">
          <InputPlayV3 v-model="v2" placeholder="email@exemplo.com" icon="mail" />
        </FieldPlay>
      </div>
    </section>

    <!-- PROP: skeleton -->
    <section>
      <h2 class="tw:text-base tw:font-semibold tw:mb-1">skeleton</h2>
      <p class="tw:text-xs tw:opacity-50 tw:mb-4"><code>boolean</code></p>
      <div class="tw:max-w-lg">
        <FieldPlay label="Carregando..." :skeleton="true">
          <InputPlayV3 :skeleton="true" />
        </FieldPlay>
      </div>
    </section>

    <!-- Composição -->
    <section>
      <h2 class="tw:text-base tw:font-semibold tw:mb-1">Composição com diferentes inputs</h2>
      <p class="tw:text-xs tw:opacity-50 tw:mb-4">O slot aceita qualquer componente como conteúdo</p>
      <div class="tw:max-w-lg tw:space-y-4">
        <FieldPlay label="Categoria" description="Selecione a categoria principal.">
          <SelectPlayV2 v-model="v3" :options="options" placeholder="Selecione..." />
        </FieldPlay>
        <FieldPlay label="Ativo">
          <ToggleButtonPlay v-model="v4" />
        </FieldPlay>
      </div>
    </section>
  </DsShowcase>
</template>

<script lang="ts" setup>
import { ref } from 'vue'
import DsShowcase from '../DsShowcase.vue'
import { FieldPlay, InputPlayV3, SelectPlayV2, ToggleButtonPlay } from "@/components/atomic"


const v1 = ref('')
const v2 = ref('')
const v3 = ref(null)
const v4 = ref(true)
const options = [
  { id: 'tech', label: 'Tecnologia' },
  { id: 'design', label: 'Design' },
  { id: 'marketing', label: 'Marketing' },
]
</script>
